import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
    Card,
    CardBody,
    Modal,
    ModalBody,
    Input,
    ModalHeader,
    Button,
    Row,
    Col,
    Label,
    FormFeedback,
    FormGroup,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DrawRequirementTable from "./DrawRequirementTable"
import { dateFormat, dateTimeFormat, formatDateToISO } from "pages/Common"
import CreateUpdateDrawRequirementModel from "./CreateUpdateDrawRequirementModel"
import ErrorModel from "common/errorModel/errorModel"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import noImage from "../../assets/images/no_image.jpg"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}



function DrawRequirementList() {
    document.title = `Draw Requirements | Raja Rani Couture`
    let { pathname } = useLocation()
    let { state } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [purchaseDoneModal, setPurchaseDoneModal] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [tableDataInputFabric, setTableDataInputFabric] = useState(
        Array.from({ length: 10 }, () => ({
            Image: '',
            OrderNo: "",
            Name: "",
            DesignerBy: 0,
            Date: new Date(),
            Stuff: "",
        }))
    );
    const [fabricInputData, setFabricInputData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const [userData, setUserData] = useState([])
    const [editData, setEditData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(state == null ? true : false)
    const [isDrawRequirementCompleted, setIsDrawRequirementCompleted] = useState(false)
    const [isDrawDeliveredCompleted, setIsDrawDeliveredCompleted] = useState(false)
    const [TaskTitleTypes, setTaskTitleTypes] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
    )
    const [cost, setCost] = useState('')
    const [IsCostError, setIsCostError] = useState(false)
    const [fabricId, setFabricId] = useState(0)
    const [image1, setImage1] = useState('')
    const [image2, setImage2] = useState('')
    const [image3, setImage3] = useState('')
    const [image4, setImage4] = useState('')
    const [orderNo, setOrderNo] = useState('')
    const [imageViewModal, setImageViewModal] = useState(false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                setUserData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    // filter data for fabric
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // fabric list api
    const DrawRequirementListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("DrawRequirement/list", {
            UserId: parseInt(userFilter),
            IsDrawRequirementCompleted: isDrawRequirementCompleted,
            isDrawDeliveredCompleted: isDrawDeliveredCompleted,
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.RequirementList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // fabric list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            DrawRequirementListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateDisble, dateFilter, isDrawRequirementCompleted, isDrawDeliveredCompleted])

    // Create fabric handler
    const handleDrawClick = () => {
        toggle()
        setIsEdit(false)
        setIsCreate(true)
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // if (!modal) {
        //     setIsEdit(false)
        // }
    }

    const toggle1 = () => {
        setModal1(!modal1)
        setFabricInputData([])
        setTableDataInputFabric(Array.from({ length: 10 }, () => ({
            Image: '',
            OrderNo: "",
            Name: "",
            DesignerBy: 0,
            Date: new Date(),
            Stuff: "",
        })))
    }

    const purchaseDoneToggle = () => {
        setPurchaseDoneModal(!purchaseDoneModal)
        setCost('')
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        setIsCreate(false)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this draw requirement permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`DrawRequirement/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Draw Requirement deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Requirement",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const MarkDoneOrderandPurchase = (Id, IsDrowDone) => {
        setformSumitLoading(true)
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to mark this draw requirement done permanently? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                postApi("DrawRequirement/mark-as-done", {
                    Id: Id,
                    IsDrowDone: IsDrowDone,
                    Cost: parseFloat(cost || 0)
                }).then(
                    ({ data, status }) => {
                        if (status === 200) {
                            setformSumitLoading(false)
                            DrawRequirementListApi()
                            toast.success("Draw Requirement done successfully", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            setformSumitLoading(false)
                            ErrorModel.errormodel({
                                title: "Verify Draw Requirement",
                                text: data,
                            })
                        }
                        setIsLoading(false)
                    }
                )
            } else {
                setIsLoading(false)
            }
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleMarkDone = (Id, IsDrowDone) => {
        setIsLoading(true)
        setFabricId(Id)
        MarkDoneOrderandPurchase(Id, IsDrowDone)
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "Image1",
                width: "5%",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        {row.original?.Image1 ? (
                            <img
                                onClick={() => handleImageView(row.original, row.original.OrderNo)}
                                src={row.original.Image1}
                                alt="Requirement"
                                style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "0px" }}
                            />
                        ) : (
                            <span>N/A</span>
                        )}
                    </div>
                ),
            },
            {
                Header: "Order. No",
                accessor: "OrderNo",
                width: "10%"
            },
            {
                Header: "Designer Name",
                accessor: "CreatedByName",
                width: "8%"
            },
            {
                Header: "Date",
                accessor: "Date",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.Date == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row?.original?.Date?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Detail",
                accessor: "Detail",
                Cell: ({ row }) => (
                    <p className=" mb-0" style={{ textWrap: "wrap" }}>
                        {row.original?.Detail == null
                            ? "N/A"
                            : row.original?.Detail}
                    </p>
                ),
            },
            {
                Header: "Require Date",
                accessor: "RequireDate",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original.RequireDate)
                            ?
                            dateFormat(row?.original?.RequireDate?.split("T")[0], "dd-MM-yyyy")
                            : (TaskTitleTypes?.includes("18")) ?
                                <>
                                    <div className="text-center">
                                        {row?.original?.DeliveredDate ?
                                            <Button
                                                color="primary"
                                                fabric="primary"
                                                className="btn btn-primary btn-sm "
                                                onClick={() => handleMarkDone(row.original.Id, true)}
                                            >
                                                Mark as Done
                                            </Button>
                                            :
                                            <Button
                                                color="secondary"
                                                fabric="secondary"
                                                className="btn btn-primary btn-sm"
                                                style={{ cursor: "not-allowed" }}
                                            >
                                                Mark as Done
                                            </Button>
                                        }
                                    </div>
                                </>
                                :
                                "N/A"}
                    </p >
                ),
            },
            {
                Header: "Delivered On",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Delivered On
                    </div>
                ),
                accessor: "DeliveredDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original.DeliveredDate)
                            ?
                            dateFormat(row?.original?.DeliveredDate?.split("T")[0], "dd-MM-yyyy")
                            : (TaskTitleTypes?.includes("19")) ?
                                <>
                                    <div className="text-center">
                                        <Button
                                            color="primary"
                                            fabric="primary"
                                            className="btn btn-primary btn-sm "
                                            onClick={() => handleMarkDone(row.original.Id, false)}
                                        >
                                            Mark as Done
                                        </Button>
                                    </div>
                                </>
                                :
                                "N/A"}
                    </p >
                ),
            },
            {
                Header: "Delivered By",
                accessor: "DeliveredByName",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.DeliveredByName || "N/A"}
                    </p>
                ),
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row?.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {(row.original.RequireDate || row.original.DeliveredDate || TaskTitleTypes?.includes("19")) ?
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        id={`edittooltip${row.original.Id}`}
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                                :
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        onClick={() => handleEdit(row.original)}
                                        id={`edittooltip${row.original.Id}`}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                            }
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Order No.", "Designer Name", "Date", "Detail", "Require Date", "Created By", "Delivered Date", "Delivered By"];
            const mainTitle = "Draw Requirements";
            const widthObj = [{
                Key: "A",
                Value: 12,
            },
            {
                Key: "B",
                Value: 20,
            },
            {
                Key: "C",
                Value: 15,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 15,
            },
            {
                Key: "F",
                Value: 12,
            },
            {
                Key: "G",
                Value: 20,
            },
            {
                Key: "H",
                Value: 15,
            },
            {
                Key: "I",
                Value: 15,
            },
            {
                Key: "J",
                Value: 18,
            },
            {
                Key: "K",
                Value: 20,
            },
            {
                Key: "L",
                Value: 15,
            },
            {
                Key: "M",
                Value: 15,
            },
            ]
            const extention = "Draw_Requirements.xlsx"
            let excelSheetData = []

            postApi("DrawRequirement/list", {
                UserId: parseInt(userFilter),
                isDrawRequirementCompleted: isDrawRequirementCompleted,
                isDrawDeliveredCompleted: isDrawDeliveredCompleted,
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.RequirementList.length; index++) {
                        let dataObj = {
                            OrderNo: data?.RequirementList[index].OrderNo || "N/A",
                            Name: data?.RequirementList[index].CreatedByName || "N/A",
                            Date: data?.RequirementList[index].CreatedOn == "" || data?.RequirementList[index].CreatedOn == null
                                ? "N/A"
                                : dateTimeFormat(data?.RequirementList[index].CreatedOn, "dd-MM-yyyy"),
                            Detail: data?.RequirementList[index].Detail || "N/A",
                            RequireDate: data?.RequirementList[index].RequireDate == "" || data?.RequirementList[index].RequireDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.RequirementList[index].RequireDate, "dd-MM-yyyy"),
                            CreatedByName: data?.RequirementList[index].CreatedByName || "N/A",
                            DeliveredDate: data?.RequirementList[index].DeliveredDate == "" || data?.RequirementList[index].DeliveredDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.RequirementList[index].DeliveredDate, "dd-MM-yyyy"),
                            DeliveredByName: data?.RequirementList[index].DeliveredByName || "N/A",
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    const handleImageView = (data, SrNo) => {
        setImage1(data.Image1)
        setImage2(data.Image2)
        setImage3(data.Image3)
        setImage4(data.Image4)
        setOrderNo(SrNo)
        imageViewToggle()
    }

    const imageViewToggle = () => {
        setImageViewModal(!imageViewModal)
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <DrawRequirementTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isDrawRequirementList={true}
                            handleDrawClick={handleDrawClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            writeDataToExcel={writeDataToExcel}
                            isDrawDeliveredCompleted={isDrawDeliveredCompleted}
                            setIsDrawDeliveredCompleted={setIsDrawDeliveredCompleted}
                            isDrawRequirementCompleted={isDrawRequirementCompleted}
                            setIsDrawRequirementCompleted={setIsDrawRequirementCompleted}
                            TaskTitleTypes={TaskTitleTypes}
                        />

                        {(isCreate || isEdit) &&
                            <CreateUpdateDrawRequirementModel
                                modal={modal}
                                toggle={toggle}
                                isEdit={isEdit}
                                editData={isEdit ? editData : ''}
                                DrawRequirementListApi={DrawRequirementListApi}
                                AssignByData={''}
                                userData={userData}
                            />
                        }

                        <Modal
                            isOpen={purchaseDoneModal}
                            toggle={purchaseDoneToggle}
                            centered={true}
                            size="sm"
                        // style={{ width: !isMobile ? "1400px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={purchaseDoneToggle} >
                                    {"Purchase Done"}
                                </ModalHeader>
                                <ModalBody>
                                    <Row>
                                        <FormGroup className="mb-2">
                                            <Label className="form-label required">Cost</Label>
                                            <Input
                                                name="cost"
                                                className="form-control-sm"
                                                type="text"
                                                placeholder="Cost"
                                                value={cost}
                                                onKeyPress={handleKeyPress}
                                                onChange={(e) => setCost(e.target.value, setIsCostError(false))}
                                                invalid={IsCostError}
                                            />
                                            {IsCostError ? (
                                                <FormFeedback type="invalid">Cost is reuired</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Row>
                                    <Row>
                                        <Col style={{ display: "flex", justifyContent: "end" }} md={12}>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    fabric="primary"
                                                    className="btn btn-primary btn-sm "
                                                    // type="submit"
                                                    onClick={() => MarkDoneOrderandPurchase(fabricId, false)}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={imageViewModal}
                            toggle={imageViewToggle}
                            centered={true}
                            size="xl"
                            style={{ width: isMobile ? "" : "1000px" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={imageViewToggle} tag="h5">
                                    Order. No: {orderNo}
                                </ModalHeader>
                                <ModalBody>
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "3px",
                                                }}
                                                width="200px"
                                                height="235px"
                                                src={image1 || noImage}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "3px",
                                                }}
                                                width="200px"
                                                height="235px"
                                                src={image2 || noImage}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "3px",
                                                }}
                                                width="200px"
                                                height="235px"
                                                src={image3 || noImage}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "3px",
                                                }}
                                                width="200px"
                                                height="235px"
                                                src={image4 || noImage}
                                            />
                                        </Col>
                                    </Row>
                                    <div style={{ display: "flex", justifyContent: "center" }}>

                                    </div>
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
DrawRequirementList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default DrawRequirementList
